<template>
  <b-row>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-col md="12">
      <b-card>
        <div slot="header">
          <strong>Usuário Varejo - Créditos</strong>
        </div>
        <b-form @submit.stop.prevent>
        <b-form-group
          label="CPF/CNPJ"
          label-for="username">
          <b-input-group>
            <b-form-input id="username" type="text" autocomplete="username" v-model="user.username" :disabled="user.id != null"></b-form-input>
            <b-input-group-append>
              <b-button type="button" variant="success" class="btn-novo form-control" @click="find">Buscar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

        <b-form-group
          label="Nome"
          label-for="name">
          <b-form-input id="name" type="text" autocomplete="name" v-model="user.name" :disabled="user.id != null"></b-form-input>
        </b-form-group>

        <b-form-group
          label="E-mail"
          label-for="email">
          <b-form-input id="email" type="text" autocomplete="email" v-model="user.email" :disabled="user.id != null"></b-form-input>
        </b-form-group>

        <b-form-group
          label="Tipo"
          label-for="userType">
          <b-form-select v-model="user.userType" id="userType">
            <option value="normal" :selected="user.userType == 'normal'">Normal</option>
            <option value="trial" :selected="user.userType == 'trial'">Trial</option>
          </b-form-select>
        </b-form-group>

        <b-form-group
          label="Número Serial"
          label-for="serialNumber">
          <b-form-input id="serialNumber" type="text" autocomplete="serialNumber" v-model="user.serialNumber"></b-form-input>
        </b-form-group>
      
        <b-form-group
          label="Vencimento"
          label-for="limit-dueDate">
          <b-form-input id="limit-dueDate" type="date" v-model="user.billingLimits.limitRules.dueDate"></b-form-input>
        </b-form-group>

        <b-form-group
          label="Autenticações"
          label-for="limit-login">
          <b-form-input id="limit-login" type="number" v-model="user.billingLimits.limitRules.login"></b-form-input>
        </b-form-group>

        <b-form-group
          label="Assinaturas"
          label-for="limit-signature">
          <b-form-input id="limit-signature" type="number" v-model="user.billingLimits.limitRules.signature"></b-form-input>
        </b-form-group>

        <div slot="footer">
          <b-row>
            <b-col sm="12" lg="2">
              <b-button class="form-control" type="submit" variant="primary" @click="save"><i class="fa fa-dot-circle-o"></i> Gravar</b-button>&nbsp;
            </b-col>
            <b-col sm="12" lg="2"> 
              <b-button class="form-control" type="button" variant="secondary" @click="goBack"><i class="fa fa-arrow-left"></i> Voltar</b-button>&nbsp;
            </b-col>
          </b-row>
        </div>
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';
import { requestError, env, normalizeRetailUserCredits } from '@/shared/utils';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'user',
  components: {
    Loading
  },
  data: () => {
    return {
      user: {
        billingLimits: {
          limitRules: {}
        }
      },
      loadCount: 0,
    }
  },
  mounted() {
    this.getUser(this.$route.params.id);
  },
  computed: {
    isLoading() {
      return this.loadCount > 0;
    }
  },
  methods: {
    formatDate(value) {
      if (!value) return null;
      return value.date.split(" ")[0];
    },
    normalizeUser(user) {
      const normalizedUser = normalizeRetailUserCredits(user || {});

      if (normalizedUser.billingLimits.limitRules.dueDate) {
        normalizedUser.billingLimits.limitRules.dueDate = this.formatDate(normalizedUser.billingLimits.limitRules.dueDate);
      }

      return normalizedUser;
    },
    find() {
      if (!this.user.username) {
        this.$bvModal.msgBoxOk('O CPF/CNPJ deve ser informado.')
          .then()
          .catch(console.error);
        return;
      }
      this.loadCount++;
      axios
        .get(`${env.urlBillingApi}/user-retail/${this.user.username}?deep=true`)
        .then((response) => {
          this.user = this.normalizeUser(response.data);
        })
        .catch((error) => {
          requestError(error);
        })
        .finally(() => {
          this.loadCount--;
        });
    },
    getUser(id) {
      if (!id) {
        return;
      }
      var _this = this;
      this.loadCount++;
      axios
        .get(`${env.urlBillingApi}/user-retail/${id}`)
        .then(function(response) {
          _this.user = _this.normalizeUser(response.data);
        })
        .catch(function(error) {
          requestError(error);
        })
        .finally(() => {
          _this.loadCount--;
        });
    },
    goBack() {
      this.$router.replace({path: '/users-retail'});
      // this.$router.go(-1);
    },
    save() {
      if (!this.validate()) {
        return;
      }
      if (this.user.id) {
        this.updateUser(this.user.id);
      } else {
        this.createUser();
      }
    },
    validate() {
      if (this.user.billingLimits.limitRules.login > 100000000 || this.user.billingLimits.limitRules.signature > 100000000) {
        alert("A quantidade de autenticações ou assinaturas não pode exceder a 100 milhões!");
        return false;
      }
      return true;
    },
    updateUser(id) {
      var _this = this;
      this.loadCount++;
      axios
        .put(`${env.urlBillingApi}/user-retail/${id}`, {
          userType: this.user.userType,
          serialNumber: this.user.serialNumber,
          credits: this.user.billingLimits.limitRules
        })
        .then(function(response) {
          _this.$bvModal.msgBoxOk('Usuário gravado com sucesso!')
            .then(value => {
              _this.$router.replace({path: '/users-retail'});
            })
            .catch(console.error);
        })
        .catch(function(error) {
          requestError(error);
        })
        .finally(() => {
          _this.loadCount--;
        });
    },
    createUser() {
      var _this = this;
      this.loadCount++;
      let user = Object.assign({}, this.user, {credits: this.user.billingLimits.limitRules});
      axios
        .post(`${env.urlBillingApi}/user-retail`, user)
        .then(function(response) {
          _this.$bvModal.msgBoxOk('Usuário gravado com sucesso!')
            .then(value => {
              _this.$router.replace({path: '/users-retail'});
            })
            .catch(console.error);
        })
        .catch(function(error) {
          requestError(error);
        })
        .finally(() => {
          _this.loadCount--;
        });
    },
    removeUser() {
      var _this = this;
      var id = this.user.id;
      if (!id) return;
      this.loadCount++;
      axios
        .delete(`${env.urlBillingApi}/user-retail/${id}`)
        .then(function(response) {
          console.log(response);
          _this.$bvModal.msgBoxOk('Usuário excluído com sucesso!')
            .then(value => {
              _this.$router.replace({path: '/users-retail'});
            })
            .catch(console.error);
        })
        .catch(function(error) {
          requestError(error);
        })
        .finally(() => {
          _this.loadCount--;
        });
    }
  }
}
</script>
